/* Optional product motion; first-paint image and all links are server rendered. */
(() => {
  function mount(root) {
    if(root.dataset.mounted)return;
    root.dataset.mounted='true';
    const q=name=>root.querySelector(`[data-hc-${name}]`);
    const video=q('hero-video'),poster=q('hero-poster'),control=q('motion-control');
    if(!video||!poster||!control)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)'),connection=navigator.connection;
    let visible=false,loaded=false,idle=false,paused=false,manual=false,motion=root.dataset.initialMotion==='true',destroyed=false;
    const auto=()=>!reduced.matches&&!connection?.saveData&&!['slow-2g','2g'].includes(connection?.effectiveType);
    function sync() {
      const playing=!video.paused;
      video.dataset.playing=String(playing&&visible&&!document.hidden&&motion);
      q('motion-label').textContent=playing?root.dataset.pause:root.dataset.play;
      q('motion-icon').textContent=playing?'Ⅱ':'▷';
      control.setAttribute('aria-label',playing?root.dataset.pause:root.dataset.play);
      control.setAttribute('aria-pressed',String(paused));control.disabled=false;
    }
    function reconcile() {
      if(destroyed||!motion||!visible||document.hidden||paused||(!manual&&(!idle||!auto()))) {video.pause();sync();return;}
      if(!loaded) {
        const webm=video.canPlayType('video/webm; codecs="vp9"')&&video.dataset.webm;
        const url=webm||video.dataset.mp4;
        if(!url){control.hidden=true;return;}
        const source=document.createElement('source');source.type=webm?'video/webm':'video/mp4';source.src=url;
        source.addEventListener('error',()=>{video.pause();video.dataset.ready='false';paused=true;control.hidden=true;});
        video.append(source);video.load();loaded=true;
      }
      video.play().catch(()=>{paused=true;sync();});
    }
    video.addEventListener('playing',()=>{video.dataset.ready='true';sync();});
    video.addEventListener('pause',sync);
    video.addEventListener('error',()=>{video.pause();video.dataset.ready='false';paused=true;control.hidden=true;});
    control.addEventListener('click',()=>{
      if(!video.paused){paused=true;video.pause();}
      else{paused=false;manual=true;video.dataset.manual='true';reconcile();}
      sync();
    });
    root.querySelectorAll('[data-hc-model]').forEach(button=>button.addEventListener('click',()=>{
      motion=button.dataset.motion==='true';
      root.querySelectorAll('[data-hc-model]').forEach(b=>{const active=b===button;b.classList.toggle('hc-active',active);b.setAttribute('aria-pressed',String(active));});
      poster.src=button.dataset.image;poster.alt=button.dataset.title;
      q('featured-title').textContent=button.dataset.title;q('featured-price').textContent=button.dataset.price;
      q('featured-link').href=button.dataset.url;
      q('motion-caption').textContent=motion?root.dataset.motionCaption:root.dataset.staticCaption;
      control.hidden=!motion;video.hidden=!motion;
      q('sticker').hidden=!motion;
      reconcile();
    }));
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;reconcile();},{threshold:.15});
    observer.observe(root.querySelector('.hc-stage'));
    const onVisibility=()=>reconcile();
    const onPreference=()=>{manual=false;delete video.dataset.manual;reconcile();};
    document.addEventListener('visibilitychange',onVisibility);reduced.addEventListener('change',onPreference);
    connection?.addEventListener?.('change',onVisibility);
    const start=()=>{idle=true;reconcile();};
    const ready=()=>{'requestIdleCallback' in window?requestIdleCallback(start,{timeout:1800}):setTimeout(start,900);};
    if(document.readyState==='complete')ready();else window.addEventListener('load',ready,{once:true});
    // A replacement section in the theme editor must not leave playing videos/listeners.
    const onUnload=event=>{if(event.target.contains(root)){destroyed=true;video.pause();observer.disconnect();document.removeEventListener('visibilitychange',onVisibility);reduced.removeEventListener('change',onPreference);connection?.removeEventListener?.('change',onVisibility);document.removeEventListener('shopify:section:unload',onUnload);}};
    document.addEventListener('shopify:section:unload',onUnload);
    sync();
  }
  document.querySelectorAll('[data-creative-home]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-creative-home]').forEach(mount));
})();
